import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "w-full bg-gray-lp-200 rounded-lg" }
const _hoisted_2 = /*#__PURE__*/_createVNode("th", {
  class: "sticky left-0 z-30 bg-gray-50 p-2 text-left",
  style: {"min-width":"48px"}
}, " No ", -1)
const _hoisted_3 = {
  class: "sticky left-12 z-30 bg-gray-50 p-2 text-left",
  style: {"min-width":"280px"}
}
const _hoisted_4 = {
  key: 0,
  class: "w-full text-left bg-gray-50 px-4 py-2"
}
const _hoisted_5 = {
  key: 1,
  class: "w-full text-left bg-white px-4 py-2"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("td", {
  class: "sticky left-0 z-20 bg-white p-2 text-center",
  style: {"min-width":"48px"}
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("td", {
  class: "sticky left-12 z-20 bg-white border-r p-2 text-left",
  style: {"min-width":"280px"}
}, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "w-full text-left px-4 py-2 bg-white"
}
const _hoisted_9 = { class: "flex flex-col items-center justify-center" }
const _hoisted_10 = { class: "text-gray-lp-300" }
const _hoisted_11 = { class: "text-gray-lp-600" }
const _hoisted_12 = {
  key: 1,
  class: "w-full text-left px-4 py-2 bg-white",
  style: {"height":"100px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_EmptyState = _resolveComponent("EmptyState")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataTable, (section, idx) => {
      return (_openBlock(), _createBlock("div", {
        key: section.title
      }, [
        _createVNode("table", null, [
          _createVNode("thead", null, [
            _createVNode("tr", null, [
              _hoisted_2,
              _createVNode("th", _hoisted_3, _toDisplayString(section.title), 1),
              (idx === 0)
                ? (_openBlock(), _createBlock("th", _hoisted_4))
                : (_openBlock(), _createBlock("th", _hoisted_5))
            ])
          ]),
          _createVNode("tbody", null, [
            _createVNode("tr", null, [
              _hoisted_6,
              _hoisted_7,
              (idx === 2 && !_ctx.isEmpty)
                ? (_openBlock(), _createBlock("td", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("dashboard.errorBreakdownTable.systemError")), 1),
                      _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("dashboard.errorBreakdownTable.reloadInstruction")), 1),
                      _createVNode(_component_LpButton, {
                        class: "mt-4",
                        color: "red-lp-100",
                        textColor: "white",
                        title: _ctx.$t('dashboard.errorBreakdownTable.reload'),
                        onClick: _ctx.reloadPage
                      }, null, 8, ["title", "onClick"])
                    ])
                  ]))
                : (_openBlock(), _createBlock("td", _hoisted_12, [
                    (_ctx.isEmpty && idx === 2)
                      ? (_openBlock(), _createBlock(_component_EmptyState, {
                          key: 0,
                          icon: "noData_empty",
                          customMessage: _ctx.$t('dashboard.errorBreakdownTable.emptyData')
                        }, null, 8, ["customMessage"]))
                      : _createCommentVNode("", true)
                  ]))
            ])
          ])
        ])
      ]))
    }), 128))
  ]))
}